// 相关参考：https://blog.csdn.net/teajs/article/details/51778225
// 微信、支付宝音频Hack方案
; void function (win, doc, undefined) {
  // 原理：调用链中的某个事件被标识为用户事件而非系统事件
  // 进而导致浏览器以为是用户触发播放而允许播放
  function elementPlay(element, constructor) {
    if (constructor) {
      constructor.prototype._play = constructor.prototype.play;
    }
    element.prototype._play = element.prototype.play;

    function wxPlay(media) {
      /// <summary>
      /// 微信播放Hack
      /// </summary>

      WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
        media._play();
      });
    }

    function alipayPlay(media) {
      /// <summary>
      /// 支付宝播放Hack
      /// </summary>

      AlipayJSBridge.call('getNetworkType', function (result) {
        media._play();
      });
    }

    function play() {
      var self = this;

      self._play();

      try {
        wxPlay(self);
      } catch (ex) {
        document.addEventListener("WeixinJSBridgeReady", function evt() {
          wxPlay(self);
          document.removeEventListener("WeixinJSBridgeReady", evt, false);
        }, false);
      }

      try {
        alipayPlay(self);
      } catch (ex) {
        document.addEventListener('AlipayJSBridgeReady', function evt() {
          alipayPlay(self);
          document.removeEventListener("AlipayJSBridgeReady", evt, false);
        }, false);
      }
    }

    if (constructor) {
      constructor.prototype.play = play;
    }
    element.prototype.play = play;
  }

  // 音频
  elementPlay(HTMLAudioElement, Audio)
  // 视频
  elementPlay(HTMLVideoElement)

}(window, document);
